import { DocumentationParams, GetDocumentationResponse, DocumentResponse } from '../types/Documentation.types';
import API from './ApiBase';

export const getDocumentation = async (params: DocumentationParams): Promise<GetDocumentationResponse> => {
  const response = await API.get<GetDocumentationResponse>('/documents', {
    params,
  });
  return response.data;
};

// Staged Upload Flow
export const prepareUpload = async (payload: {
  aiSystemId: string;
  fileName: string;
  contentType: string;
  fileSize: number;
  category: string;
  pathPrefix?: string;
  conformityAssessmentType?: 'INTERNAL' | 'EXTERNAL';
}) => {
  const response = await API.post('/documents/prepare-upload', payload);
  return response.data;
};

export const finalizeUpload = async (payload: {
  uploadId: string;
  etag?: string;
}) => {
  const response = await API.post('/documents/finalize-upload', payload);
  return response.data;
};

export const downloadDocument = async (documentId: string): Promise<DocumentResponse> => {
  const response = await API.get<DocumentResponse>(`/documents/${documentId}/download`);
  return response.data;
};

export const deleteDocument = async (documentId: string): Promise<{ message: string }> => {
  const response = await API.delete<{ message: string }>(`/documents/${documentId}`);
  return response.data;
};

export interface FinishSigningPayload {
  result?: string | null;
  envelopeId?: string | null;
}

export const finishDocumentSigning = async (
  documentId: string,
  payload: FinishSigningPayload,
): Promise<DocumentResponse> => {
  const response = await API.post<DocumentResponse>(
    `/documents/${documentId}/sign/finish`,
    payload,
  );
  return response.data;
};

export const signDocument = async (payload: { documentId: string; returnUrl: string }): Promise<string> => {
  const response = await API.post<string>(`/documents/sign`, payload);
  return response.data;
};
